/**
 * Health Check API - Main Export
 * Combines all API modules into a single interface
 */
import { createCustomCheckApi } from "./customCheckApi";
import { createLegacyApi } from "./legacyApi";
import { createResultsApi } from "./resultsApi";
export function createHealthCheckApi(registry, legacyAdapter, api) {
    // Create sub-APIs
    const customApi = createCustomCheckApi(registry, api);
    const legacyApi = createLegacyApi(legacyAdapter, registry);
    const resultsApi = createResultsApi(registry);
    return {
        custom: customApi,
        legacy: legacyApi,
        results: resultsApi,
        /**
         * Run all health checks
         * @returns Combined results from all checks
         */
        runAll: async () => {
            return registry.runAllHealthChecks(api);
        },
        runChecksByTrigger: async (trigger) => {
            return registry.runChecksByTrigger(trigger, api);
        },
    };
}
